/* eslint-disable object-shorthand */
const tintColorLight = '#444'; // BB6A0F';
const snapCalorieOrange = '#fd7250';
const snapCalorieLightOrange = '#fdab50';
const buttonBlue = '#2196F3';

export default {
  light: {
    text: '#000',
    background: '#f6f6f6',
    tint: tintColorLight,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorLight,
    tabBackgroundSelected: snapCalorieLightOrange,
    orange: snapCalorieLightOrange,
    textInputBackground: '#fff',
  },
  dark: {
    text: '#000',
    background: '#f6f6f6',
    tint: tintColorLight,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorLight,
    tabBackgroundSelected: snapCalorieLightOrange,
    orange: snapCalorieLightOrange,
    textInputBackground: '#fff',
  },
  snapCalorie: {
    background: '#f6f6f6',
    orange: snapCalorieOrange,
    lightOrange: snapCalorieLightOrange,
    cardBackground: '#fff',
    buttonBlue: buttonBlue,
    linkColor: 'rgb(51,51,51)',
    textColor: '#505050',
  },
  mocks: {
    textYellow: '#deea5a',
    textGray: '#4e5b70',
    textDarkBlue: '#09203f',
    backgroundColorLightBlue: '#214779',
    backgroundColorDarkBlue: '#09203f',
    backgroundColorWhite: '#ffffff',
    backgroundColorLightGray: '#f5f5f5',
    borderLightGray: '#dddddd',
    borderDarkGray: '#999999',
  },
};
